import { motion } from "framer-motion";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const EASE = [0.22, 1, 0.36, 1];

export default function FaqSection({ t }) {
    return (
        <section id="faq" className="border-t border-white/5 px-5 sm:px-8 py-24 sm:py-28">
            <div className="mx-auto max-w-3xl">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, ease: EASE }}
                    className="mb-12 text-center"
                >
                    <p className="flex items-center justify-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-glacier">
                        <span className="inline-block h-px w-10 bg-glacier/60" />
                        {t.faq.overline}
                        <span className="inline-block h-px w-10 bg-glacier/60" />
                    </p>
                    <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight">
                        {t.faq.title}
                    </h2>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 28 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.7, ease: EASE }}
                >
                    <Accordion type="single" collapsible data-testid="faq-accordion" className="w-full">
                        {t.faq.items.map((item, i) => (
                            <AccordionItem
                                key={i}
                                value={`faq-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="border-white/10"
                            >
                                <AccordionTrigger className="text-left font-display text-base sm:text-lg font-medium text-ivory hover:text-glacier hover:no-underline py-5">
                                    {item.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-sm sm:text-[15px] leading-relaxed text-fog">
                                    {item.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </motion.div>
            </div>
        </section>
    );
}
